/* eslint-disable react/require-default-props */
import type { CSSProperties, FC, MouseEventHandler, ReactElement } from 'react';
import React from 'react';

import { cnIcon } from './Icon.cn';

import './Icon.css';
import './_glyph/Icon_glyph.css';

export interface IconProps {
    /**
     * Направление иконки
     * @default top
     */
    direction?: 'left' | 'top' | 'right' | 'bottom';

    /**
     * Размер иконки
     */
    size?: '2xs' | 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl';

    /**
     * CSS-стили иконки
     *
     * @default {}
     */
    style?: CSSProperties;

    /**
     * Дополнительный класс
     */
    className?: string;

    /**
     * Контент иконки
     */
    children?: ReactElement;

    /**
     * Всплывающая подсказка
     */
    title?: string;

    color?: 'secondary' | 'tertiary' | 'error' | (string & {});
    /**
     * Обработчик, который вызывается при клике на иконку
     */
    onClick?: MouseEventHandler<HTMLSpanElement>;
}

const getIconColor = (color: IconProps['color']): string | undefined => {
    switch (color) {
        case 'secondary':
            return 'var(--hr-color-text-secondary)';
        case 'tertiary':
            return 'var(--hr-color-text-tertiary)';
        case 'error':
            return 'var(--hr-color-special-error)';
        default:
            return color;
    }
};
/**
 * Компонент для вставки иконки.
 * @param {IconProps} props
 */
export const Icon: FC<IconProps> = ({
    direction = 'top',
    size,
    style,
    children,
    title,
    color,
    onClick,
    // Извлекаем свойства, т.к. они не нужны на DOM узле
    // FIXME: https://github.com/bem/bem-react/issues/381
    // @ts-expect-error
    type: _type,
    // @ts-expect-error
    glyph: _glyph,
    ...props
}) => {
    const className = cnIcon({ direction, size }, [props.className]);

    const iconColor = getIconColor(color);
    return (
        <span
            {...props}
            aria-hidden
            className={className}
            style={{
                '--hr-icon-color': iconColor,
                ...style,
            }}
            title={title}
            onClick={onClick}
        >
            {children}
        </span>
    );
};

Icon.displayName = cnIcon();
